import { USER_ROLES } from './authConstants';

export const MCP_WRITE_MODES = { NONE: 'none', SELECTED: 'selected', FULL: 'full' };
export const MCP_WRITE_MODE_CHOICES = [
  { id: MCP_WRITE_MODES.NONE, name: 'Read only' },
  { id: MCP_WRITE_MODES.SELECTED, name: 'Write to selected tables' },
  { id: MCP_WRITE_MODES.FULL, name: 'Full write (every table below)' },
];
export const MCP_APPROVER_ROLES = [USER_ROLES.ADMIN, USER_ROLES.MEDIA_MANAGER];
